// extracted by mini-css-extract-plugin
module.exports = {"base":"PillInput__base__LNmSj","input":"PillInput__input__2NgA1"};